export default __webpack_public_path__ + "static/media/arrow.cbad26db.svg";